import http from "../http-common";
import authService from '../components/api-authorization/AuthorizeService';

class UploadFilesService {
    async upload(file, districtId, userId, onUploadProgress) {
        const token = await authService.getAccessToken();
        let formData = new FormData();
        formData.append("file", file);
        formData.append("districtId", districtId);
        formData.append("userId", userId);
        return http.post("api/upload/upload", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": `Bearer ${token}`
            },
            onUploadProgress,
        });
    }
    async getFiles(districtId) {
        const token = await authService.getAccessToken();
        return http.get("api/upload/DistrictFiles?districtId=" + districtId, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
    }
}
export default new UploadFilesService();